const unitsConstant = {
	HELP_THUMBNAIL_UPLOAD_SIZE: 2097152,
	HELP_VIDEO_UPLOAD_SIZE: 104857600
};

Object.freeze(unitsConstant);
export default unitsConstant;
